module.exports = __webpack_public_path__ + "img/Programmes.9355dfec.svg";